import React from 'react'
import './Misionvision.css'
import edificiosImage from '../assets/icons/edificios_myv.jpg'
import misionIcon from '../assets/icons/bx-btnmision.svg';
import visionIcon from '../assets/icons/bx-btnvision.svg';
import valoresIcon from '../assets/icons/bs-btnvalores.svg';

function Misionvision() {
    return (
        <section id="mision-vision-section" className="section-container">
      <div className='inner'>
      <h2 className="section-title">NUESTROS COMPROMISOS</h2>
      <div className="content-wrapper">
        <div className="image-container-mv">
          <img src={edificiosImage} alt="Sky and buildings" className="section-image" />
        </div>
        <div className="content-container">
          <div className="subsection">
            <h3>MISIÓN <img src={misionIcon} alt="Misión" className="icon" /></h3>
            <p>Brindar un servicio único y de calidad a nuestros clientes, con proyectos de altos estándares de calidad con uso actualizado en tecnologías.</p>
            <hr />
          </div>
          <div className="subsection">
            <h3>VISIÓN <img src={visionIcon} alt="Visión" className="icon" /></h3>
            <p>Ser una empresa lider en diseño, construcción e ingeniería reconocida por ser confiable y comprometida, generando cambios positivos en la vida de las comunidades y el medio ambiente.</p>
            <hr />
          </div>
          <div className="subsection">
            <h3>VALORES <img src={valoresIcon} alt="Valores" className="icon" /></h3>
            <p>Priorizamos la integridad en todos los procesos, asegurando plazos cumplidos y decisiones éticas. Nos comprometemos socialmente para mejorar la calidad de vida actual y futura, incorporando prácticas ecológicas en nuestros proyectos.</p>
            <hr />
          </div>
        </div>
        </div>
      </div>
    </section>
    )
}

export default Misionvision